import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutShippingAddressUpdate = ({ country }) => (
	`mutation checkoutShippingAddressUpdateV2($shippingAddress: MailingAddressInput!, $checkoutId: ID!) @inContext(country: ${country}) {
		checkoutShippingAddressUpdateV2(shippingAddress: $shippingAddress, checkoutId: $checkoutId) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutShippingAddressUpdate;
